import React, { useState } from 'react';
import { Box, SxProps, Theme, useTheme } from '@mui/material';
import { Tenant } from '../types/tenant';
import { logoPerSfondo } from '../utils/logoTenant';

interface TenantLogoProps {
  tenant: Pick<Tenant, 'id' | 'name' | 'logoBlob' | 'logoDarkBlob'> | null | undefined;
  /** Altezza massima del logo: la larghezza segue le proporzioni. */
  height: number | string;
  maxWidth?: number | string;
  /** Fondo scuro sotto il logo. Se non lo si dice, lo decide il tema. */
  scuro?: boolean;
  /** Cosa mostrare se la scuola non ha un logo (o non si carica): di solito il nome. */
  fallback?: React.ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Il logo della scuola, scelto per il fondo su cui sta.
 * Sul fondo scuro senza la variante apposta il logo principale va in un
 * riquadro chiaro, cosi' un logo scuro resta leggibile.
 */
const TenantLogo: React.FC<TenantLogoProps> = ({ tenant, height, maxWidth = 240, scuro, fallback = null, sx }) => {
  const theme = useTheme();
  const logo = logoPerSfondo(tenant, scuro ?? theme.palette.mode === 'dark');
  const [rotto, setRotto] = useState<string | null>(null);

  if (!logo || rotto === logo.src) return <>{fallback}</>;

  const img = (
    <Box
      component="img"
      src={logo.src}
      alt={tenant?.name || ''}
      onError={() => setRotto(logo.src)}
      sx={{ display: 'block', maxHeight: height, maxWidth, width: 'auto', height: 'auto', objectFit: 'contain', ...(logo.riquadro ? {} : (sx as any)) }}
    />
  );
  if (!logo.riquadro) return img;
  return (
    <Box sx={{ display: 'inline-flex', bgcolor: '#fff', borderRadius: 1.5, px: 1.25, py: 0.75, ...(sx as any) }}>
      {img}
    </Box>
  );
};

export default TenantLogo;
